import './careers.css';
import React from 'react';
import hardware from '../../images/careersPage/careers-hardware.png';
import HardwareText from './HardwareText';

const Hardware = () => {
  return (
    <div className="hardware-container container">
      <div className="imagedivHardware">
        <img className="desktopHardwareImage" src={hardware} />
      </div>
      <img className="mobileHardwareImage" src={hardware} />
      <div className="innerbox">
        <div className="header">HARDWARE</div>
        <HardwareText />
      </div>
    </div>
  );
};

export default Hardware;



// WEBPACK FOOTER //
// ./src/components/Careers/Hardware.js